<template>
  <div class="widthFull h-100 somatoline pb-5" id="top">
    <loading v-if="loadingState" />
  </div>
</template>


<script>
import { mapGetters, mapState } from "vuex";
import axios from "axios";
import { ACCEPT_COOKIES, USER_REQUEST } from "actions/user";
import { ACCEPT_REG, AUTH_LOGOUT, AUTH_REQUEST } from "actions/auth";

const moment = require("moment");

export default {
  name: "Play",

  data() {
    return {
      loadingState: false,
      piva: "",
      phone: "",
      promo: "",
      cod: "",
    };
  },
  methods: {
    logFromUrl: async function (param, idUser, promo, phone) {
      this.loadingState = true;
      var _vue = this;
      this.$track("QRcode", "START");
      this.$track("QRcode -> userToken", idUser);
      this.$track("QRcode -> promo", promo);
      this.$track("QRcode -> phone", phone);
      this.$track("QRcode -> param", param);
      var data = {
        userToken: idUser,
        id_promo: promo,
        phone: phone,
        password: param,
        id_platform: process.env.ID_PLATFORM,
        unique_key_db: process.env.UNIQUE_KEY_DB,
        vector_unique_key_db: process.env.ICODE,
      };
      data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
      await axios({
        method: "POST",
        data: { data },
        url: process.env.ROOT_API + "api/logFromUrl",
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
          this.$track("QRcode", "SUCCESS");
          this.$track("QRcode", resp.data);
          this.piva = resp.data[0].piva;
          this.cod = resp.data[0].cod;
          this.phone = phone;
          this.promo = promo;
          if (resp.data == "access_denied") {
            this.message =
              '<b class="Bold">Non hai accesso a questa promozione</b>';
            this.UploadError("", this.message);
          }
          var data = {
            username: process.env.LOGIN_WITH_EMAIL
              ? resp.data[0].email
              : resp.data[0].cod,
            password: resp.data[0].password,
            case: "login_from_url",
            id_platform: process.env.ID_PLATFORM,
            unique_key_db: process.env.UNIQUE_KEY_DB,
            vector_unique_key_db: process.env.ICODE,
          };
          data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
          this.$store.dispatch(AUTH_REQUEST, { data }).then((resp) => {
            this.$store.dispatch(ACCEPT_REG, promo);
            this.$store.dispatch(ACCEPT_COOKIES, true);
            this.$store.dispatch(USER_REQUEST);
            this.$track("AUTH_REQUEST", "SUCCESS");

            setTimeout(function () {
              _vue.$router.push(
                "/play/" +
                  _vue.promo +
                  "/" +
                  _vue.piva +
                  "/" +
                  _vue.cod
              );
            }, 200);
            this.loadingState = false;
          });
        })
        .catch((resp) => {
          this.$store
            .dispatch(AUTH_LOGOUT)
            .then(() => this.$router.push("/login"));
          this.loadingState = false;
        });
    },
    UploadError(desc, specific) {
      this.$swal({
        type: "error",
        title: desc,
        html: specific,
        confirmButtonText: "CHIUDI",
        confirmButtonColor: "#15267",
        onClose: () => {
          this.$router.push("/");
        },
      });
    },
  },
  /********************************************************************************************* */
  watch: {
    getProfile: function () {
      var _vue = this;
    },
  },
  mounted: function () {
    if (this.$route.params.token) {
      this.link = this.$route.params.token;

      var idPromo = this.link.substring(
        this.link.lastIndexOf("WERgt4r2sfr") + 11,
        this.link.lastIndexOf("REWrfs2r4tg")
      );

      var idSearch = this.link.substring(
        this.link.lastIndexOf("TOKhgsfddte") + 11,
        this.link.lastIndexOf("KOTnaskdue")
      );

      var str = this.link.substring(
        this.link.lastIndexOf("REWrfs2r4tg") + 11,
        this.link.lastIndexOf("TOKhgsfddte")
      );

      this.phone = 1;
      idSearch = this.$decryptByAES(idSearch, process.env.CRYPTKEY);
      this.steps = str.replaceAll("2TGRS2", "/");
      this.steps1 = this.steps.replaceAll("3MULTI3", ".");
      this.logFromUrl(this.steps1, idSearch, idPromo, this.phone);
    } else {
      this.$router.push("/");
    }
  },
  created: async function () {},
  computed: {
    ...mapGetters([
      "getProfile",
      "isAuthenticated",
      "isProfileLoaded",
      "acceptCookies",
      "accepted_regulations",
    ]),
    ...mapState({
      authLoading: (state) => state.auth.status === "loading",
      profile: (state) => state.user.profile,
    }),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/uploadphone/index.vue